import Loader, {
	LoaderSizeTypes,
	LoaderVariantTypes,
} from '@components/ui/loader/Loader';

export default function ButtonLoader({
	size,
	variant,
}: Readonly<{ size: LoaderSizeTypes; variant: LoaderVariantTypes }>) {
	return (
		<span className="absolute inset-0 flex h-full w-full items-center justify-center">
			<Loader
				tag="span"
				size={size}
				variant={variant}
				showOnlyThreeDots={true}
			/>
		</span>
	);
}

ButtonLoader.displayName = 'ButtonLoader';
